<template>
  <b-card
    title="مدیریت کارنه تیر"
  >
    <b-row>

      <b-col
        class="table-size"
      >
        <div class="custom-search">
          <b-row>
            <div class="filter-row">
              <b-button
                class="mb-1 mr-auto ml-1"
                variant="primary"
                @click="addRow()"
              >
                جدید
              </b-button>
              <b-col md="2">
                <b-form-group
                  label="عنوان"
                  label-for="Title"
                >
                  <b-form-input
                    v-model="filterOptions.Title"
                    @keyup.enter="update(1)"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                  label="وضعیت"
                  label-for="IsActive"
                >
                  <v-select
                    v-model="filterOptions.IsActive"
                    :options="enums('IsActive')"
                    dir="rtl"
                    label="text"
                    :reduce="x => x.value"
                  />
                </b-form-group>
              </b-col>
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                class="mb-1 mr-1"
                variant="warning"
                @click="update(1)"
              >فیلتر
              </b-button>
            </div>
          </b-row>
        </div>

        <b-table
          bordered
          hover
          striped
          :items="items"
          :fields="fields"
          class="mt-1 mb-2 position-relative"
          responsive
          :busy="loading"
        >
          <template #cell(Id)="data">
            <b-link
              class="font-weight-bold"
              @click="updateRow(data.item)"
            >
              #{{ data.value }}
            </b-link>
          </template>

          <template #cell(IsActive)="data">
            <b-badge
              :variant="data.value ? 'success' : 'warning'"
            >
              {{ data.value ? 'فعال' : 'غیرفعال' }}
            </b-badge>
          </template>

          <template #cell(actions)="data">

            <div
              class="text-nowrap"
            >
              <b-link @click="updateRow(data.item)">
                <feather-icon
                  :id="`invoice-row-${data.item.Id}-send-icon`"
                  icon="EditIcon"
                  size="16"
                />
              </b-link>

              <feather-icon
                icon="TrashIcon"
                size="16"
                class="ml-1 cursor-pointer"
                @click="remove(data.item.Id)"
              />
            </div>
          </template>

          <template #table-busy>
            <div
              class="text-center my-2"
            >
              <b-spinner
                variant="primary"
                class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>

        </b-table>

        <z-pagination
          :page="filterOptions.Page"
          :per-page.sync="filterOptions.PerPage"
          :total-rows="totalRows"
          :loading="loading"
          @change="update"
        />

      </b-col>

    </b-row>

    <b-modal
      v-if="showModal"
      v-model="showModal"
      ok-title="ذخیره"
      cancel-title="انصراف"
      cancel-variant="outline-secondary"
      centered
      title="جزئیات کارنه تیر"
      :no-close-on-backdrop="true"
      size="md"
      @ok="save"
    >
      <b-row>
        <b-col md="12">
          <b-form-group
            label="عنوان"
            label-for="Title"
          >
            <b-form-input
              v-model="row.Title"
              autocomplete="off"
            />
          </b-form-group>
        </b-col>

        <b-col md="6">
          <b-form-group
            label="ترتیب"
            label-for="Sort"
          >
            <b-form-input
              v-model.number="row.Sort"
              type="number"
              autocomplete="off"
            />
          </b-form-group>
        </b-col>

        <b-col md="6">
          <b-form-group
            label="وضعیت"
            label-for="IsActive"
          >
            <v-select
              v-model="row.IsActive"
              :options="enums('IsActive')"
              dir="rtl"
              label="text"
              :clearable="false"
              :reduce="x => x.value"
            />
          </b-form-group>
        </b-col>

        <b-col md="12">
          <b-form-group
            label="توضیحات"
            label-for="Description"
          >
            <b-form-textarea
              v-model="row.Description"
              rows="2"
              no-resize
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
  </b-card>
</template>

<script>

export default {
  name: 'TirCarnet',
  data() {
    return {
      totalRows: 1000 * 1000,
      loading: false,
      filterOptions: {
        Title: null,
        IsActive: null,
        Page: 1,
        PerPage: 10,
      },
      showModal: false,
      row: {},
      fields: [
        {
          key: 'Id',
          label: '#',
          thClass: 'col-width-50',
        },
        {
          key: 'Title',
          label: 'عنوان',
        },
        {
          key: 'Sort',
          label: 'ترتیب',
        },
        {
          key: 'IsActive',
          label: 'وضعیت',
        },
        {
          key: 'actions',
          label: '',
          thClass: 'col-width-50',
        },
      ],
      items: [],
    }
  },
  created() {
    if (this.$store.state.zirehState.listFilter[this.$options.name]) {
      this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
    }
    this.update()
  },
  methods: {
    update(pageNumber) {
      this.loading = true

      this.filterOptions.Page = pageNumber || this.filterOptions.Page

      this.$store.commit('zirehState/setListFilter', { key: this.$options.name, value: this.filterOptions })

      this.$http.post(
        this.$api.tircarnet.getlist, this.filterOptions,
      )
        .then(res => {
          this.totalRows = res.totalRow
          this.items = res.data
        })
        .finally(() => {
          this.loading = false
        })
    },
    save() {
      let url = this.$api.tircarnet.add
      if (this.row.Id) {
        url = this.$api.tircarnet.update
      }

      this.$http.post(
        url, this.row,
      )
        .then(() => {
          this.update()
        })
        .catch(() => {
          this.showModal = true
        })
    },
    addRow() {
      this.row = {
        Title: null, Description: null, Sort: 0, IsActive: true,
      }
      this.showModal = true
    },
    updateRow(row) {
      this.row = JSON.parse(JSON.stringify(row))
      this.showModal = true
    },
    remove(id) {
      this.removeRow(this.$api.tircarnet.remove, 'Id', id)
    },
  },
}
</script>
